"use strict";

exports.__esModule = true;
exports.default = void 0;
var _overArg = _interopRequireDefault(require("./_overArg.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = (0, _overArg.default)(Object.keys, Object);
var _default = exports.default = nativeKeys;